import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo } from 'react';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import defaultClasses from './downloads.module.css';
import { useDownloads } from '../../../../peregrine/talons/ProductFullDetail/Downloads/useDownloads';
import { useMergeCssClasses } from '../../../../../Utils/utils';

var Downloads = function Downloads(props) {
  var _product$custom_attri, _product$custom_attri2, _product$custom_attri3, _JSON$parse, _JSON$parse2;

  var _props$specSheetUrl = props.specSheetUrl,
      specSheetUrl = _props$specSheetUrl === void 0 ? true : _props$specSheetUrl,
      _props$installationSh = props.installationSheetUrl,
      installationSheetUrl = _props$installationSh === void 0 ? null : _props$installationSh,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? null : _props$icon,
      _props$isOutlet = props.isOutlet,
      isOutlet = _props$isOutlet === void 0 ? false : _props$isOutlet,
      _props$familyCustomPd = props.familyCustomPdfs,
      familyCustomPdfs = _props$familyCustomPd === void 0 ? false : _props$familyCustomPd,
      product = props.product,
      _props$isPdp = props.isPdp,
      isPdp = _props$isPdp === void 0 ? false : _props$isPdp;
  var talonProps = useDownloads();
  var pimcoreAssetHost = talonProps.pimcoreAssetHost;

  var _useAppContext = useAppContext(),
      _useAppContext2 = _slicedToArray(_useAppContext, 2),
      toggleDrawer = _useAppContext2[1].toggleDrawer;

  var classes = useMergeCssClasses(defaultClasses, props.classes); // specSheetUrl should just be a link to download dynamic pdp tearsheet (the same one that will sit next to wishlist button)

  var familyCustomPdfsElements = product === null || product === void 0 ? void 0 : (_product$custom_attri = product.custom_attributes) === null || _product$custom_attri === void 0 ? void 0 : (_product$custom_attri2 = _product$custom_attri.find(function (item) {
    return item.attribute_metadata.code == 'hf_custom_pdfs';
  })) === null || _product$custom_attri2 === void 0 ? void 0 : (_product$custom_attri3 = _product$custom_attri2.entered_attribute_value) === null || _product$custom_attri3 === void 0 ? void 0 : _product$custom_attri3.value;
  return React.createElement("div", {
    className: "".concat(classes.root)
  }, familyCustomPdfs && React.createElement("div", {
    className: classes.wrapper
  }, familyCustomPdfsElements && ((_JSON$parse = JSON.parse(familyCustomPdfsElements)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.filter(function (item) {
    return typeof item === 'string';
  }).map(function (item, index, sheets) {
    // item is a filename path, extract the filename without the extension and the path
    var filename = item.split('/').pop().split('.')[0];
    return React.createElement("div", {
      key: index,
      className: "".concat(classes.buttonWrapper, " ").concat(isPdp && 'basis-full')
    }, React.createElement("a", {
      href: pimcoreAssetHost + item,
      alt: filename,
      target: "_blank",
      key: item + '-key',
      rel: "noopener"
    }, React.createElement("div", {
      className: "".concat(classes.downloadBtnWrapper, " ").concat(isPdp && classes.pdpBtnWrapper)
    }, icon, React.createElement("div", {
      className: classes.downloadBtn
    }, filename))));
  }))), (specSheetUrl || installationSheetUrl) && !familyCustomPdfs && React.createElement("div", {
    className: classes.wrapper
  }, React.createElement("div", {
    className: "".concat(classes.buttonWrapper, " ").concat(isPdp && 'basis-full')
  }, specSheetUrl && !isOutlet && React.createElement("div", {
    className: "".concat(classes.downloadBtnWrapper, " ").concat(isPdp && classes.pdpBtnWrapper),
    onClick: function onClick() {
      return toggleDrawer('pdpTearsheetDownload');
    }
  }, icon, React.createElement("button", {
    className: classes.downloadBtn,
    "aria-label": "Specifications Sheet" // by default button is submit and
    // it triggers add to cart form
    ,
    type: "button"
  }, "Specifications Sheet"))), installationSheetUrl && ((_JSON$parse2 = JSON.parse(installationSheetUrl)) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.filter(function (item) {
    return typeof item === 'string';
  }).map(function (item, index, sheets) {
    var counter = index + 1;
    var moreThenOne = sheets.length > 1;
    return React.createElement("div", {
      key: index,
      className: "".concat(classes.buttonWrapper, " ").concat(isPdp && 'basis-full')
    }, React.createElement("a", {
      href: pimcoreAssetHost + item,
      alt: "Download Installation Instructions",
      target: "_blank",
      key: item + '-key',
      rel: "noopener"
    }, React.createElement("div", {
      className: "".concat(classes.downloadBtnWrapper, " ").concat(isPdp && classes.pdpBtnWrapper)
    }, icon, React.createElement("div", {
      className: classes.downloadBtn
    }, "Installation Sheet ", moreThenOne && "".concat(counter)))));
  }))));
};

export default Downloads;